// src/components/MainLayout.tsx

import React from 'react';
import { Panel, PanelGroup, PanelResizeHandle } from 'react-resizable-panels';
import { BiSolidWidget } from "react-icons/bi";
import { WidgetContainer } from './WidgetContainer';
import { GridLayout } from './GridLayout';
import { Layout } from '../types/Layout';
import './MainLayout.scss';

interface MainLayoutProps {
  layout: Layout;
  onLayoutChange: (newLayout: Layout) => void;
}

export const MainLayout: React.FC<MainLayoutProps> = ({
  layout,
  onLayoutChange,
}) => {
  const [activeView, setActiveView] = React.useState<'conversation' | 'events'>('conversation');

  const handleHorizontalResize = (sizes: number[]) => {
    onLayoutChange({
      ...layout,
      size: 100 - sizes[0]
    });
  };

  return (
    <div className="content-main">
      <PanelGroup direction="horizontal" className="panel-group" onLayout={handleHorizontalResize}>
        <Panel defaultSize={100 - layout.size} minSize={0}>
          <div className="widget-container">
            {layout.main?.widgetName ? (
              <WidgetContainer widgetName={layout.main?.widgetName} />
            ) : (
              <div className="empty-widget"><BiSolidWidget size={100} /></div>
            )}
          </div>
        </Panel>
        {(layout.columns !== 0 && layout.rows !== 0) &&
          <>
            <PanelResizeHandle className="resize-handle" />
            <Panel defaultSize={layout.size} minSize={0}>
              <div className="right-panel-container">
                <GridLayout
                  layout={layout}
                  onLayoutChange={onLayoutChange}
                />
              </div>
            </Panel>
          </>
        }
      </PanelGroup>
    </div>
  );
};